/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function BusinessAccountIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V8ZM20 8L4 8V20H20V8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V8ZM20 8L4 8V20H20V8Z"
        fill="url(#paint0_radial_14255_160230)"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4V7H15V4H9V7H7V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4V7H15V4H9V7H7V4Z"
        fill="url(#paint1_radial_14255_160230)"
        fillOpacity="0.1"
      />
      <path d="M4 14H20V20H4V14Z" fill="currentColor" />
      <path
        d="M4 14H20V20H4V14Z"
        fill="url(#paint2_radial_14255_160230)"
        fillOpacity="0.1"
      />
      <path d="M10 12H14V10H10V12Z" fill="currentColor" />
      <path
        d="M10 12H14V10H10V12Z"
        fill="url(#paint3_radial_14255_160230)"
        fillOpacity="0.1"
      />
      <defs>
        <radialGradient
          id="paint0_radial_14255_160230"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 20.5) rotate(22.6199) scale(19.5 20.3562)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_14255_160230"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 20.5) rotate(22.6199) scale(19.5 20.3562)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_14255_160230"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 20.5) rotate(22.6199) scale(19.5 20.3562)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_14255_160230"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 20.5) rotate(22.6199) scale(19.5 20.3562)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

BusinessAccountIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default BusinessAccountIcon
